import { DestinationEvent } from '@eventbrite/event-renderer';
import React, { useState } from 'react';
import { v4 as UUID } from 'uuid';
import { DateOption } from '../../../../components/DateFilterDropdown';
import { NoFilterResults } from '../../../../components/NoFilterResults';
import { TopActivitiesProps } from '../../../../containers/TopActivities';
import { BentoCarousel } from '../../components/BentoCarousel';
import styles from './CategoryCarousel.module.scss';

export interface EventData {
    category: string;
    events: DestinationEvent[];
}
export interface CategoryCarouselProps {
    category_events?: {
        [key: string]: EventData;
    };
    topActivities?: TopActivitiesProps;
    isLoading: boolean;
    populatedCategoriesCount?: number;
    setNumCarousels: React.Dispatch<React.SetStateAction<number>>;
    locationData: {
        latitude: number;
        longitude: number;
        isOnline?: boolean;
    };
    pageType: 'POI' | 'TTD' | '';
    handleToggle: (idx: number) => void;
    changeDateSelection: React.Dispatch<React.SetStateAction<DateOption>>;
}

export const CategoryCarousel = (props: CategoryCarouselProps) => {
    const {
        category_events,
        isLoading,
        populatedCategoriesCount,
        setNumCarousels,
        handleToggle,
        changeDateSelection,
    } = props;
    const [isAnyEvents, setIsAnyEvents] = useState(false);
    setNumCarousels(populatedCategoriesCount ?? 1);

    const events = Object.keys(category_events ?? {}).map((k) => {
        if (!category_events) return null;
        const isEvents = category_events[k].events.length > 0;

        if (!isAnyEvents && isEvents) {
            setIsAnyEvents(true);
        }

        return (
            <>
                {isEvents && (
                    <div key={k}>
                        <BentoCarousel
                            title={category_events[k].category}
                            events={category_events[k].events}
                        />
                    </div>
                )}
            </>
        );
    });

    const RenderCards = () => {
        if (isLoading) {
            return (
                <div
                    className={styles.categoryCarousel}
                    data-testid="category-carousel"
                >
                    {Array.from({ length: populatedCategoriesCount ?? 1 }).map(
                        () => (
                            <BentoCarousel key={UUID()} isLoading={true} />
                        ),
                    )}
                </div>
            );
        } else if (!isAnyEvents) {
            return (
                <NoFilterResults
                    locationData={props.locationData}
                    pageType={props.pageType}
                    handleToggle={handleToggle}
                    changeDateSelection={changeDateSelection}
                />
            );
        } else {
            return (
                <div
                    className={styles.categoryCarousel}
                    data-testid="category-carousel"
                >
                    {events}
                </div>
            );
        }
    };

    return <RenderCards />;
};
